import { USER_ERROR, USER_REQUEST, USER_SUCCESS } from '../actions/user'
import { AUTH_LOGOUT } from '../actions/auth'
import router from '../../router'
import { ApiService } from '../../service/api/ApiService'
import avatar from '../../assets/img/header/avatar/anonim.png'
import { EventBus } from '../../event-bus/event-bus'

const state = {
    status: '',
    userInfo: {
        personal_cabinet: {},
        profile: {},
    },
}

const getters = {
    getUserInfo: state => state.userInfo,
    getPersonalCabinet: state => state.userInfo.personal_cabinet,
    getProfile: state => state.userInfo.profile,
    getAvatar (state) {
        if (state.userInfo.profile === null) {
            return avatar
        }

        if (state.userInfo.profile.avatar) {
          // eslint-disable-next-line no-undef
            return process.env.VUE_APP_API_URL + '/storage/' + state.userInfo.profile.avatar
        }
        return avatar
    },
}

const mutations = {
    [USER_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [USER_SUCCESS]: (state, { data }) => {
        state.status = 'success'
        state.userInfo = Object.assign({}, state.userInfo, data)
        EventBus.$emit('filterMenu')
        EventBus.$emit('userSuccessfullyFetched')
    },
    [USER_ERROR]: (state) => {
        state.status = 'error'
    },
    [AUTH_LOGOUT]: (state) => {
        state.profile = {}
    },
}

const actions = {
    [USER_REQUEST]: ({ commit, dispatch }) => {
        commit(USER_REQUEST)
        return ApiService.get('me').then(resp => {
            commit(USER_SUCCESS, resp)
            return resp
        }).catch(resp => {
            commit(USER_ERROR)
            dispatch(AUTH_LOGOUT)
            router.push({ name: 'authorization' })
        })
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
